import { useState, useEffect, useRef } from 'react';
import api from '../api';

export function useSmartCompose(text, threadId, clientId) {
  const [suggestion, setSuggestion] = useState('');
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);
  const abortRef = useRef(null);

  useEffect(() => {
    setSuggestion('');

    if (!text || !text.trim() || !threadId) return;

    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (abortRef.current) abortRef.current.abort();

    debounceRef.current = setTimeout(async () => {
      abortRef.current = new AbortController();
      setLoading(true);
      try {
        const res = await api.post(
          '/api/smart-compose/suggest/',
          { current_text: text, thread_id: String(threadId), client_id: String(clientId ?? '') },
          { signal: abortRef.current.signal }
        );
        setSuggestion(res.data?.suggestion ?? '');
      } catch (err) {
        if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
          setSuggestion('');
        }
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      if (abortRef.current) abortRef.current.abort();
    };
  }, [text, threadId, clientId]);

  return { suggestion, loading };
}

export default useSmartCompose;
